import { css } from 'aphrodite/no-important';
import { PieChart, Pie, Sector, Cell, ResponsiveContainer } from 'recharts';
import * as React from 'react';
import College from 'src/models/College.js';
import { getCollegeStats } from 'src/core/api';
import { getRandomColor } from 'src/views/Utils';
import {styles} from "src/styles/HomePage";
import { CardHeader, ListGroup, ListGroupItem } from 'reactstrap';


interface IHomePageProps {
    history: any
}

class CollegeItem {

    public readonly id : number;
    public readonly name: string;
    public readonly count: number
    public readonly color: any

    constructor(id: number,name: string,count: number, color: any) {
        this.id = id
        this.name = name
        this.count = count
        this.color = color
    }
}

class HomePageState {
    public readonly data : CollegeItem[]
    public readonly activeIndex: number
    
    constructor(){
        this.data = getCollegeStats().map((college: College) => {
            return new CollegeItem(
                college.id,
                college.name,
                college.count,
                getRandomColor()
            )
        });
        this.activeIndex = 0
    }
}


class HomePage extends React.Component<IHomePageProps,HomePageState> {

    constructor(props: IHomePageProps) {
        super(props)
        this.state = new HomePageState();
    }

    public render() {
        return (
            <div id="content" className={css(styles.content)} >
                
                <div id="welcome_message" className={css(styles.welcomeMessage)} >
                    Welcome to UD Research Portal. The aim of the portal is to provide exploratory capabilities and analytics of sponsored research
                    data of UD researchers to better enable research development efforts. You will also be able to explore publication abstracts and
                    related data of UD researchers.
                    A variety of search functionality is also provided and we will continue to improve the portal with time. While every attempt is
                    made to keep data up to date and the derived analytics is based on certain assumptions, this should not be seen as a supplement for faculty
                    annual report. We welcome feedback and bug reports. Click Bug Report button under the support tab on top to send us information.
                </div>
                <div className={css(styles.buttonContainer)} >
                <div id="college" className={css(styles.button)} onClick={this.onCollegeClick} >
                                        Continue
                </div>
                </div>
               {/*
                <div className={css(styles.buttonContainer)} >
                    <div id="sponsors" className={css(styles.button)} onClick={this.onSponsorClick}>
                        Sponsors
                    </div>

                    <div id="college" className={css(styles.button)} onClick={this.onCollegeClick} >
                        Colleges
                    </div>
                    
                    <div id="institutes" className={css(styles.button)}onClick={this.onCollegeClick}>
                        Institutes
                    </div>

                    <div id="faculty" className={css(styles.button)}onClick={this.onFacultyClick}>
                        Faculty
                    </div>
                    
                </div>
                  */}
            </div>
        )      
    }     
    
    private onCollegeClick = (event: any) =>  {
        this.props.history.push("/colleges-research-institutes")
    }

    private onFacultyClick = (event: any) =>  {
        this.props.history.push("/faculty")
    }
 private onSponsorClick = (event: any) =>  {
        this.props.history.push("/sponsors")
    }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/pages/HomePage.tsx